import styles from "./paymentDetailsPopup.module.css";
import { tWithKeyAttr as t } from "../../../i18nHelper";

interface PaymentDetailsPopupProps {
  onClose: () => void;
  /* 
    TODO: Payment Details Integration
    - Replace hardcoded values with actual data from payment endpoint
    - Add props for: paymentDate, paymentMethod, invoiceUrl/invoiceId
    - Implement "View Invoice" link to open/download invoice
  */
  paymentDate?: string;
  paymentMethod?: string;
  invoiceUrl?: string;
}

function PaymentDetailsPopup({ 
  onClose,
  // TODO: Replace default values with actual data from endpoint
  paymentDate = "12/12/25",
  paymentMethod = "מזומן", // Cash in Hebrew
  invoiceUrl = "#"
}: PaymentDetailsPopupProps) {
  return (
    <div className={styles.popup} data-testid="payment-details-popup">
      <button
        type="button"
        className={styles.closeBtn}
        onClick={onClose}
        aria-label={t("CLOSE")}
      >
        ✕
      </button>
      <p className={styles.text}>
        {t("PAID_ON_DATE")}: {paymentDate}
      </p>
      <p className={styles.text}>
        {t("PAYMENT_METHOD")}: {paymentMethod}
      </p>
      <a 
        href={invoiceUrl} 
        className={styles.invoiceLink}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          // TODO: Implement actual invoice viewing/download logic
          if (invoiceUrl === "#") {
            e.preventDefault();
          }
        }}
      >
        {t("VIEW_INVOICE")}
      </a>
    </div>
  );
}

export default PaymentDetailsPopup;
